import { Link, useLocation } from "react-router-dom";
import React, { useState, useEffect } from "react";

import web_desktop from "../images/web_desktop.jpg";
import web_mobile from "../images/web_mobile.jpg";

const OldHome = (props) => {

  return (
    <picture>
      <source media="(min-width: 1000px)" srcset={web_desktop} width="100%" />
      <source media="(min-width: 465px)" srcset={web_mobile} width="100%" />
      <img src={web_mobile} width="100%" />
    </picture>
  );
};

export default OldHome;
